var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("breadcrumb-top", {
        attrs: { breadcrumbConfig: _vm.dataList, isBack: "1" },
      }),
      _c("div", { staticClass: "content c-top" }, [
        _vm._m(0),
        _c(
          "div",
          { staticStyle: { "margin-top": "40px", "margin-bottom": "40px" } },
          [
            _c(
              "el-form",
              { attrs: { model: _vm.pageData, rules: _vm.ruleForm } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "页面标题",
                      prop: "title",
                      "label-width": "100px",
                    },
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "请输入页面标题" },
                      model: {
                        value: _vm.pageData.title,
                        callback: function ($$v) {
                          _vm.$set(_vm.pageData, "title", $$v)
                        },
                        expression: "pageData.title",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "状态",
                      prop: "status",
                      "label-width": "100px",
                    },
                  },
                  [
                    _c(
                      "el-radio",
                      {
                        attrs: { label: true },
                        model: {
                          value: _vm.pageData.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.pageData, "status", $$v)
                          },
                          expression: "pageData.status",
                        },
                      },
                      [_vm._v("启用")]
                    ),
                    _c(
                      "el-radio",
                      {
                        attrs: { label: false },
                        model: {
                          value: _vm.pageData.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.pageData, "status", $$v)
                          },
                          expression: "pageData.status",
                        },
                      },
                      [_vm._v("禁用")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "page-content" }, [
          _c(
            "div",
            { staticClass: "modul" },
            [
              _c(
                "div",
                {
                  staticStyle: { "margin-bottom": "18px", "margin-top": "3px" },
                },
                [_vm._v("功能模块")]
              ),
              _vm._l(_vm.modulList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "modul-item",
                    on: {
                      click: function ($event) {
                        return _vm.addModul(index)
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "addicon",
                      attrs: {
                        src: require("../../../assets/icon_add_blue@2x.png"),
                        alt: "",
                      },
                    }),
                    _c("span", [_vm._v(_vm._s(item))]),
                  ]
                )
              }),
            ],
            2
          ),
          _c("div", { staticClass: "phone-view" }, [
            _c(
              "div",
              { staticClass: "phone-scroll" },
              [
                _vm._l(_vm.viewData, function (item, index) {
                  return [
                    item.modelType == 1
                      ? _c(
                          "div",
                          {
                            staticClass: "pr mg-bttom",
                            style: {
                              "margin-bottom": item.margin
                                ? item.margin + "px"
                                : "20px",
                            },
                            on: {
                              mouseleave: function ($event) {
                                return _vm.handleCloseBar($event, index)
                              },
                              mouseenter: function ($event) {
                                return _vm.handleShowBar($event, index)
                              },
                              click: function ($event) {
                                return _vm.handleView(index)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "phone-search" }, [
                              _vm._m(1, true),
                              _c("div", { staticClass: "search-btn" }, [
                                _vm._v(
                                  _vm._s(item.modelDetail.navName || "搜索")
                                ),
                              ]),
                            ]),
                            _c("tool-bar", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.showBar1 || item.showBar2,
                                  expression: "item.showBar1 || item.showBar2",
                                },
                              ],
                              attrs: {
                                viewIndex: index,
                                viewlist: _vm.viewData,
                              },
                              on: {
                                toDown: _vm.toDown,
                                toUp: _vm.toUp,
                                toEdit: _vm.toEdit,
                                toDel: _vm.toDel,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    item.modelType == 2
                      ? _c(
                          "div",
                          {
                            staticClass: "pr mg-bttom",
                            style: {
                              "margin-bottom": item.margin
                                ? item.margin + "px"
                                : "20px",
                            },
                            on: {
                              mouseleave: function ($event) {
                                return _vm.handleCloseBar($event, index)
                              },
                              mouseenter: function ($event) {
                                return _vm.handleShowBar($event, index)
                              },
                              click: function ($event) {
                                return _vm.handleView(index)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "swiper-box",
                                style: {
                                  height:
                                    item.radioHeight == "2" && item.height
                                      ? item.height + "px"
                                      : "124px",
                                },
                              },
                              [
                                _c(
                                  "el-carousel",
                                  {
                                    attrs: {
                                      "indicator-position": "none",
                                      arrow: "never",
                                      height:
                                        item.radioHeight == "2" && item.height
                                          ? item.height + "px"
                                          : "124px",
                                    },
                                  },
                                  _vm._l(
                                    item.modelDetail.swiperImageList,
                                    function (sItem, sIndex) {
                                      return _c(
                                        "el-carousel-item",
                                        { key: sIndex },
                                        [
                                          sItem.imgUrl
                                            ? _c("img", {
                                                staticClass: "swiper-img",
                                                attrs: {
                                                  src: sItem.imgUrl,
                                                  alt: "",
                                                },
                                              })
                                            : _vm._e(),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("tool-bar", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.showBar1 || item.showBar2,
                                  expression: "item.showBar1 || item.showBar2",
                                },
                              ],
                              attrs: {
                                viewIndex: index,
                                viewlist: _vm.viewData,
                              },
                              on: {
                                toDown: _vm.toDown,
                                toUp: _vm.toUp,
                                toEdit: _vm.toEdit,
                                toDel: _vm.toDel,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    item.modelType == 3
                      ? _c(
                          "div",
                          {
                            staticClass: "pr",
                            style: {
                              "margin-bottom": item.margin
                                ? item.margin + "px"
                                : "",
                            },
                            on: {
                              mouseleave: function ($event) {
                                return _vm.handleCloseBar($event, index)
                              },
                              mouseenter: function ($event) {
                                return _vm.handleShowBar($event, index)
                              },
                              click: function ($event) {
                                return _vm.handleView(index)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "two-num",
                                style: {
                                  "justify-content":
                                    item.modelDetail.categoryNavList.length == 2
                                      ? "space-around"
                                      : "",
                                },
                              },
                              _vm._l(
                                item.modelDetail.categoryNavList,
                                function (itemx, indexx) {
                                  return _c(
                                    "div",
                                    {
                                      key: indexx,
                                      staticClass: "two-num-item",
                                      style: {
                                        flex:
                                          item.modelDetail.categoryNavList
                                            .length == 2
                                            ? "flex"
                                            : "",
                                        width:
                                          item.modelDetail.categoryNavList
                                            .length >= 5
                                            ? "20%"
                                            : "",
                                      },
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "nav-img",
                                        attrs: {
                                          src:
                                            itemx.imgUrl ||
                                            require("../../../assets/img_pic3@2x.png"),
                                          alt: "",
                                        },
                                      }),
                                      _c("p", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              itemx.categoryNavName
                                                ? itemx.categoryNavName
                                                : "分类导航" + (indexx + 1)
                                            ) +
                                            " "
                                        ),
                                      ]),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                            _c("tool-bar", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.showBar1 || item.showBar2,
                                  expression: "item.showBar1 || item.showBar2",
                                },
                              ],
                              attrs: {
                                viewIndex: index,
                                viewlist: _vm.viewData,
                              },
                              on: {
                                toDown: _vm.toDown,
                                toUp: _vm.toUp,
                                toEdit: _vm.toEdit,
                                toDel: _vm.toDel,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    item.modelType == 4
                      ? _c(
                          "div",
                          {
                            staticClass: "pr mg-bttom",
                            style: {
                              "margin-bottom": item.margin
                                ? item.margin + "px"
                                : "20px",
                            },
                            on: {
                              mouseleave: function ($event) {
                                return _vm.handleCloseBar($event, index)
                              },
                              mouseenter: function ($event) {
                                return _vm.handleShowBar($event, index)
                              },
                              click: function ($event) {
                                return _vm.handleView(index)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "active-box" }, [
                              _c(
                                "div",
                                { staticClass: "one-img" },
                                _vm._l(
                                  item.modelDetail.imgList,
                                  function (itemx, indexx) {
                                    return _c("img", {
                                      key: indexx,
                                      staticClass: "active-img",
                                      attrs: {
                                        src:
                                          itemx.imgUrl ||
                                          require("../../../assets/img_pic2@2x.png"),
                                        alt: "",
                                      },
                                    })
                                  }
                                ),
                                0
                              ),
                            ]),
                            _c("tool-bar", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.showBar1 || item.showBar2,
                                  expression: "item.showBar1 || item.showBar2",
                                },
                              ],
                              attrs: {
                                viewIndex: index,
                                viewlist: _vm.viewData,
                              },
                              on: {
                                toDown: _vm.toDown,
                                toUp: _vm.toUp,
                                toEdit: _vm.toEdit,
                                toDel: _vm.toDel,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    item.modelType == 5
                      ? _c(
                          "div",
                          {
                            staticClass: "pr mg-bttom",
                            style: {
                              "margin-bottom": item.margin
                                ? item.margin + "px"
                                : "20px",
                            },
                            on: {
                              mouseleave: function ($event) {
                                return _vm.handleCloseBar($event, index)
                              },
                              mouseenter: function ($event) {
                                return _vm.handleShowBar($event, index)
                              },
                              click: function ($event) {
                                return _vm.handleView(index)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "title-box",
                                style: {
                                  "justify-content":
                                    item.modelDetail.showType == 2
                                      ? "center"
                                      : "",
                                },
                              },
                              [
                                _c("div", { staticClass: "main-title" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.modelDetail.mainTitle || "主标题"
                                      ) +
                                      " "
                                  ),
                                ]),
                                _c("div", { staticClass: "secondary-title" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.modelDetail.subTitle || "") +
                                      " "
                                  ),
                                ]),
                              ]
                            ),
                            _c("tool-bar", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.showBar1 || item.showBar2,
                                  expression: "item.showBar1 || item.showBar2",
                                },
                              ],
                              attrs: {
                                viewIndex: index,
                                viewlist: _vm.viewData,
                              },
                              on: {
                                toDown: _vm.toDown,
                                toUp: _vm.toUp,
                                toEdit: _vm.toEdit,
                                toDel: _vm.toDel,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    item.modelType == 6
                      ? _c(
                          "div",
                          {
                            staticClass: "pr mg-bttom",
                            style: {
                              "margin-bottom": item.margin
                                ? item.margin + "px"
                                : "20px",
                            },
                            on: {
                              mouseleave: function ($event) {
                                return _vm.handleCloseBar($event, index)
                              },
                              mouseenter: function ($event) {
                                return _vm.handleShowBar($event, index)
                              },
                              click: function ($event) {
                                return _vm.handleView(index)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "active-box" },
                              [
                                _vm._l(
                                  item.modelDetail.activityNavList,
                                  function (itemx) {
                                    return [
                                      itemx.showType == 1
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "one-img",
                                              staticStyle: {
                                                height: "auto",
                                                "margin-bottom": "10px",
                                              },
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "active-img",
                                                staticStyle: { height: "100%" },
                                                attrs: {
                                                  src:
                                                    itemx.imgUrl ||
                                                    require("../../../assets/img_pic2@2x.png"),
                                                  alt: "",
                                                },
                                              }),
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    "text-align": "center",
                                                    "font-size": "12px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      itemx.navModel.activeName
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass: "two-img",
                                              staticStyle: {
                                                "margin-bottom": "10px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "two-img-box",
                                                  staticStyle: {
                                                    "margin-right": "5px",
                                                    height: "auto",
                                                  },
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass: "active-img",
                                                    staticStyle: {
                                                      height: "84px",
                                                    },
                                                    attrs: {
                                                      src:
                                                        itemx.imgUrl ||
                                                        require("../../../assets/img_pic2@2x.png"),
                                                      alt: "",
                                                    },
                                                  }),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "center",
                                                        "font-size": "12px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          itemx.navModel
                                                            .activeName
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "two-img-box",
                                                  staticStyle: {
                                                    height: "auto",
                                                  },
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass: "active-img",
                                                    staticStyle: {
                                                      height: "84px",
                                                    },
                                                    attrs: {
                                                      src:
                                                        itemx.children[0]
                                                          .imgUrl ||
                                                        require("../../../assets/img_pic2@2x.png"),
                                                      alt: "",
                                                    },
                                                  }),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "center",
                                                        "font-size": "12px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          itemx.children[0]
                                                            .navModel.activeName
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                    ]
                                  }
                                ),
                              ],
                              2
                            ),
                            _c("tool-bar", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.showBar1 || item.showBar2,
                                  expression: "item.showBar1 || item.showBar2",
                                },
                              ],
                              attrs: {
                                viewIndex: index,
                                viewlist: _vm.viewData,
                              },
                              on: {
                                toDown: _vm.toDown,
                                toUp: _vm.toUp,
                                toEdit: _vm.toEdit,
                                toDel: _vm.toDel,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    item.modelType == 7
                      ? _c(
                          "div",
                          {
                            staticClass: "pr mg-bttom",
                            style: {
                              "margin-bottom": item.margin
                                ? item.margin + "px"
                                : "20px",
                            },
                            on: {
                              mouseleave: function ($event) {
                                return _vm.handleCloseBar($event, index)
                              },
                              mouseenter: function ($event) {
                                return _vm.handleShowBar($event, index)
                              },
                              click: function ($event) {
                                return _vm.handleView(index)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "phone-goods" },
                              _vm._l(
                                item.modelDetail.goodsList,
                                function (itemx) {
                                  return _c(
                                    "div",
                                    { staticClass: "phone-goods-item" },
                                    [
                                      _c("img", {
                                        staticClass: "phone-goods-img",
                                        attrs: { src: itemx.imgUrl, alt: "" },
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "phone-goods-title" },
                                        [_vm._v(_vm._s(itemx.goodsName))]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "phone-goods-price" },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "retail-price" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-size": "10px",
                                                  },
                                                },
                                                [_vm._v("￥")]
                                              ),
                                              _vm._v(
                                                _vm._s(itemx.retailPrice) + " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "p",
                                            { staticClass: "market-price" },
                                            [
                                              _vm._v(
                                                "￥" + _vm._s(itemx.marketPrice)
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                            _c("tool-bar", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.showBar1 || item.showBar2,
                                  expression: "item.showBar1 || item.showBar2",
                                },
                              ],
                              attrs: {
                                viewIndex: index,
                                viewlist: _vm.viewData,
                              },
                              on: {
                                toDown: _vm.toDown,
                                toUp: _vm.toUp,
                                toEdit: _vm.toEdit,
                                toDel: _vm.toDel,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
          ]),
          _vm.viewData.length > 0 && _vm.viewIndex > -1
            ? _c("div", { staticClass: "page-right" }, [
                _c("span", { staticClass: "edit-title" }, [_vm._v("内容编辑")]),
                _c("div", { staticClass: "line" }),
                _c(
                  "div",
                  { staticClass: "edit-top" },
                  [
                    _vm.viewData[_vm.viewIndex].modelType == 1
                      ? _c("div", { staticClass: "edit-name" }, [
                          _vm._v(" 搜索框设置 "),
                        ])
                      : _vm._e(),
                    _vm.viewData[_vm.viewIndex].modelType == 2
                      ? _c("div", { staticClass: "edit-name" }, [
                          _vm._v(" 轮播图设置 "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#909099",
                                "font-weight": "500",
                              },
                            },
                            [_vm._v("（最多可上传10张轮播图）")]
                          ),
                        ])
                      : _vm._e(),
                    _vm.viewData[_vm.viewIndex].modelType == 3
                      ? _c("div", { staticClass: "edit-name" }, [
                          _vm._v(" 分类导航设置 "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#909099",
                                "font-weight": "500",
                              },
                            },
                            [
                              _vm._v(
                                "（图标建议JPG、JPEG、PNG格式，大小94*94px，5M以内）"
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm.viewData[_vm.viewIndex].modelType == 5
                      ? _c("div", { staticClass: "edit-name" }, [
                          _vm._v(" 标题导航设置 "),
                        ])
                      : _vm._e(),
                    _vm.viewData[_vm.viewIndex].modelType == 4
                      ? _c("div", { staticClass: "edit-name" }, [
                          _vm._v(" 图片导航设置 "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#909099",
                                "font-weight": "500",
                              },
                            },
                            [
                              _vm._v(
                                "（图标建议JPG、JPEG、PNG格式，宽度尺寸建议684px，5M以内）"
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm.viewData[_vm.viewIndex].modelType == 6
                      ? _c("div", { staticClass: "edit-name" }, [
                          _vm._v(" 活动专区导航设置 "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#909099",
                                "font-weight": "500",
                              },
                            },
                            [_vm._v("（图标建议JPG、JPEG、PNG格式，5M以内）")]
                          ),
                        ])
                      : _vm._e(),
                    _vm.viewData[_vm.viewIndex].modelType == 7
                      ? _c("div", { staticClass: "edit-name" }, [
                          _vm._v(" 商品导航设置 "),
                        ])
                      : _vm._e(),
                    _vm.viewData[_vm.viewIndex].modelType == 2 ||
                    _vm.viewData[_vm.viewIndex].modelType == 3 ||
                    _vm.viewData[_vm.viewIndex].modelType == 4 ||
                    _vm.viewData[_vm.viewIndex].modelType == 6
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.addNav(
                                  _vm.viewIndex,
                                  _vm.viewData[_vm.viewIndex].modelType
                                )
                              },
                            },
                          },
                          [_vm._v("添加导航")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticStyle: { "margin-bottom": "18px", color: "#606266" },
                  },
                  [
                    _c("span", { staticStyle: { "font-size": "14px" } }, [
                      _vm._v("模块间距："),
                    ]),
                    _c("el-input", {
                      staticStyle: { width: "300px" },
                      attrs: {
                        size: "mini",
                        placeholder:
                          "请输入间距大小（不输入选择默认高度）单位px",
                      },
                      model: {
                        value: _vm.viewData[_vm.viewIndex].margin,
                        callback: function ($$v) {
                          _vm.$set(_vm.viewData[_vm.viewIndex], "margin", $$v)
                        },
                        expression: "viewData[viewIndex].margin",
                      },
                    }),
                  ],
                  1
                ),
                _vm.viewData[_vm.viewIndex].modelType == 2
                  ? _c(
                      "div",
                      {
                        staticClass: "edit-name",
                        staticStyle: { "margin-bottom": "20px" },
                      },
                      [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: "1" },
                            model: {
                              value: _vm.viewData[_vm.viewIndex].radioHeight,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.viewData[_vm.viewIndex],
                                  "radioHeight",
                                  $$v
                                )
                              },
                              expression: "viewData[viewIndex].radioHeight",
                            },
                          },
                          [_vm._v("标准高度")]
                        ),
                        _c(
                          "el-radio",
                          {
                            attrs: { label: "2" },
                            model: {
                              value: _vm.viewData[_vm.viewIndex].radioHeight,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.viewData[_vm.viewIndex],
                                  "radioHeight",
                                  $$v
                                )
                              },
                              expression: "viewData[viewIndex].radioHeight",
                            },
                          },
                          [_vm._v("自定义高度")]
                        ),
                        _vm.viewData[_vm.viewIndex].radioHeight == "2"
                          ? _c("el-input", {
                              staticStyle: { width: "120px" },
                              attrs: {
                                size: "mini",
                                placeholder: "请输入高度 px",
                              },
                              model: {
                                value: _vm.viewData[_vm.viewIndex].height,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.viewData[_vm.viewIndex],
                                    "height",
                                    $$v
                                  )
                                },
                                expression: "viewData[viewIndex].height",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.viewData[_vm.viewIndex].modelType == 1
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "导航名称：",
                                  "label-width": "100px",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "200px" },
                                  attrs: {
                                    placeholder: "请输入导航名称",
                                    maxlength: "6",
                                    "show-word-limit": "",
                                  },
                                  model: {
                                    value:
                                      _vm.viewData[_vm.viewIndex].modelDetail
                                        .navName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.viewData[_vm.viewIndex].modelDetail,
                                        "navName",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "viewData[viewIndex].modelDetail.navName",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "关联页面：",
                                  "label-width": "100px",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "442px",
                                      height: "36px",
                                      background: "#e9ecfe",
                                      color: "#2d46ee",
                                      "line-height": "36px",
                                      "padding-left": "10px",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showDialog(
                                          _vm.viewIndex,
                                          0,
                                          _vm.viewData[_vm.viewIndex]
                                            .modelDetail.navModel.navType,
                                          _vm.viewData[_vm.viewIndex]
                                            .modelDetail.navModel
                                            .goodsSelectedId
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.viewData[_vm.viewIndex]
                                            .modelDetail.navModel.funcName
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.viewData[_vm.viewIndex].modelType == 2
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-table",
                          {
                            attrs: {
                              data: _vm.viewData[_vm.viewIndex].modelDetail
                                .swiperImageList,
                              "header-cell-style": {
                                background: "#F5F6FA",
                                color: "#303033",
                                "font-weight": "bold",
                                "text-align": "left",
                              },
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                type: "index",
                                label: "排序",
                                width: "70",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: { label: "名称" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: { placeholder: "请输入内容" },
                                          model: {
                                            value: scope.row.imgName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "imgName",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.imgName",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2887891545
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "图片",
                                prop: "imgUrl",
                                width: "150px",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("upload-picture", {
                                          attrs: { imageUrl: scope.row.imgUrl },
                                          on: {
                                            getUrl: function ($event) {
                                              return _vm.getImage(
                                                $event,
                                                _vm.viewIndex,
                                                scope.$index
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3181940043
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { label: "关联类型", width: "150px" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.navModel.navType == 0
                                          ? _c("p", [_vm._v("-")])
                                          : _vm._e(),
                                        scope.row.navModel.navType == 1
                                          ? _c("p", [_vm._v("功能跳转")])
                                          : _vm._e(),
                                        scope.row.navModel.navType == 2
                                          ? _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.navModel.navType ==
                                                    2 &&
                                                    _vm.classifyType == "2" &&
                                                    scope.row.navModel.labelId
                                                    ? "分类标签"
                                                    : "分类类目"
                                                )
                                              ),
                                            ])
                                          : _vm._e(),
                                        scope.row.navModel.navType == 3
                                          ? _c("p", [_vm._v("商品")])
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                694616236
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { label: "关联页面" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "toselect",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showDialog(
                                                  _vm.viewIndex,
                                                  scope.$index,
                                                  scope.row.navModel.navType,
                                                  scope.row.navModel
                                                    .goodsSelectedId
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.navModel.funcName
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                544041203
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { label: "操作", align: "center" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.$index <
                                        _vm.viewData[_vm.viewIndex].modelDetail
                                          .swiperImageList.length -
                                          1
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-right": "12px",
                                                  color: "#2d46ee",
                                                  cursor: "pointer",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toTableDown(
                                                      _vm.viewIndex,
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("下移")]
                                            )
                                          : _vm._e(),
                                        scope.$index > 0
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-right": "12px",
                                                  color: "#2d46ee",
                                                  cursor: "pointer",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toTabelUp(
                                                      _vm.viewIndex,
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("上移")]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "red",
                                              cursor: "pointer",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.tableDel(
                                                  _vm.viewIndex,
                                                  scope.$index
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                4125074247
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.viewData[_vm.viewIndex].modelType == 3
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-table",
                          {
                            attrs: {
                              data: _vm.viewData[_vm.viewIndex].modelDetail
                                .categoryNavList,
                              "header-cell-style": {
                                background: "#F5F6FA",
                                color: "#303033",
                                "font-weight": "bold",
                                "text-align": "left",
                              },
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                type: "index",
                                label: "排序",
                                width: "70",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "图标",
                                prop: "imgUrl",
                                width: "150px",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("upload-picture", {
                                          attrs: { imageUrl: scope.row.imgUrl },
                                          on: {
                                            getUrl: function ($event) {
                                              return _vm.getImage(
                                                $event,
                                                _vm.viewIndex,
                                                scope.$index
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3181940043
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { label: "名称" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: { placeholder: "请输入内容" },
                                          model: {
                                            value: scope.row.categoryNavName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "categoryNavName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.categoryNavName",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1768634227
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { label: "关联类型", width: "150px" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.navModel.navType == 0
                                          ? _c("p", [_vm._v("-")])
                                          : _vm._e(),
                                        scope.row.navModel.navType == 1
                                          ? _c("p", [_vm._v("功能跳转")])
                                          : _vm._e(),
                                        scope.row.navModel.navType == 2
                                          ? _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.navModel.navType ==
                                                    2 &&
                                                    _vm.classifyType == "2" &&
                                                    scope.row.navModel.labelId
                                                    ? "分类标签"
                                                    : "分类类目"
                                                )
                                              ),
                                            ])
                                          : _vm._e(),
                                        scope.row.navModel.navType == 3
                                          ? _c("p", [_vm._v("商品")])
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                694616236
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { label: "关联页面" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "toselect",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showDialog(
                                                  _vm.viewIndex,
                                                  scope.$index,
                                                  scope.row.navModel.navType,
                                                  scope.row.navModel
                                                    .goodsSelectedId
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.navModel.funcName
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                544041203
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { label: "操作", align: "center" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.$index <
                                        _vm.viewData[_vm.viewIndex].modelDetail
                                          .categoryNavList.length -
                                          1
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-right": "12px",
                                                  color: "#2d46ee",
                                                  cursor: "pointer",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toTableDown(
                                                      _vm.viewIndex,
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("下移")]
                                            )
                                          : _vm._e(),
                                        scope.$index > 0
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-right": "12px",
                                                  color: "#2d46ee",
                                                  cursor: "pointer",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toTabelUp(
                                                      _vm.viewIndex,
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("上移")]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "red",
                                              cursor: "pointer",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.tableDel(
                                                  _vm.viewIndex,
                                                  scope.$index
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                4281129091
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.viewData[_vm.viewIndex].modelType == 4
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-table",
                          {
                            attrs: {
                              data: _vm.viewData[_vm.viewIndex].modelDetail
                                .imgList,
                              "header-cell-style": {
                                background: "#F5F6FA",
                                color: "#303033",
                                "font-weight": "bold",
                                "text-align": "left",
                              },
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                type: "index",
                                label: "排序",
                                width: "70",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "图片",
                                prop: "imgUrl",
                                width: "150px",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("upload-picture", {
                                          attrs: { imageUrl: scope.row.imgUrl },
                                          on: {
                                            getUrl: function ($event) {
                                              return _vm.getImage(
                                                $event,
                                                _vm.viewIndex,
                                                scope.$index
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3181940043
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { label: "关联类型", width: "150px" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.navModel.navType == 0
                                          ? _c("p", [_vm._v("-")])
                                          : _vm._e(),
                                        scope.row.navModel.navType == 1
                                          ? _c("p", [_vm._v("功能跳转")])
                                          : _vm._e(),
                                        scope.row.navModel.navType == 2
                                          ? _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.navModel.navType ==
                                                    2 &&
                                                    _vm.classifyType == "2" &&
                                                    scope.row.navModel.labelId
                                                    ? "分类标签"
                                                    : "分类类目"
                                                )
                                              ),
                                            ])
                                          : _vm._e(),
                                        scope.row.navModel.navType == 3
                                          ? _c("p", [_vm._v("商品")])
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                694616236
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { label: "关联页面" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "toselect",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showDialog(
                                                  _vm.viewIndex,
                                                  scope.$index,
                                                  scope.row.navModel.navType,
                                                  scope.row.navModel
                                                    .goodsSelectedId
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.navModel.funcName
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                544041203
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { label: "操作", align: "center" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.$index <
                                        _vm.viewData[_vm.viewIndex].modelDetail
                                          .imgList.length -
                                          1
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-right": "12px",
                                                  color: "#2d46ee",
                                                  cursor: "pointer",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toTableDown(
                                                      _vm.viewIndex,
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("下移")]
                                            )
                                          : _vm._e(),
                                        scope.$index > 0
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-right": "12px",
                                                  color: "#2d46ee",
                                                  cursor: "pointer",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toTabelUp(
                                                      _vm.viewIndex,
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("上移")]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "red",
                                              cursor: "pointer",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.tableDel(
                                                  _vm.viewIndex,
                                                  scope.$index
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3069136873
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.viewData[_vm.viewIndex].modelType == 5
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "主标题名称",
                                  "label-width": "100px",
                                  size: "small",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "300px" },
                                  attrs: {
                                    placeholder: "请输入主标题名称",
                                    "show-word-limit": "",
                                    maxlength: "6",
                                  },
                                  model: {
                                    value:
                                      _vm.viewData[_vm.viewIndex].modelDetail
                                        .mainTitle,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.viewData[_vm.viewIndex].modelDetail,
                                        "mainTitle",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "viewData[viewIndex].modelDetail.mainTitle",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "显示方式",
                                  "label-width": "100px",
                                  size: "small",
                                },
                              },
                              [
                                _c(
                                  "el-radio",
                                  {
                                    attrs: { label: 1 },
                                    model: {
                                      value:
                                        _vm.viewData[_vm.viewIndex].modelDetail
                                          .showType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.viewData[_vm.viewIndex]
                                            .modelDetail,
                                          "showType",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "viewData[viewIndex].modelDetail.showType",
                                    },
                                  },
                                  [_vm._v("居左")]
                                ),
                                _c(
                                  "el-radio",
                                  {
                                    attrs: { label: 2 },
                                    model: {
                                      value:
                                        _vm.viewData[_vm.viewIndex].modelDetail
                                          .showType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.viewData[_vm.viewIndex]
                                            .modelDetail,
                                          "showType",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "viewData[viewIndex].modelDetail.showType",
                                    },
                                  },
                                  [_vm._v("居中")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "副标题名称",
                                  "label-width": "100px",
                                  size: "small",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "300px" },
                                  attrs: {
                                    placeholder: "请输入副标题名称",
                                    "show-word-limit": "",
                                    maxlength: "6",
                                  },
                                  model: {
                                    value:
                                      _vm.viewData[_vm.viewIndex].modelDetail
                                        .subTitle,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.viewData[_vm.viewIndex].modelDetail,
                                        "subTitle",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "viewData[viewIndex].modelDetail.subTitle",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-top": "20px" },
                                attrs: {
                                  label: "关联页面",
                                  "label-width": "100px",
                                  size: "small",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "442px",
                                      height: "36px",
                                      background: "#e9ecfe",
                                      color: "#2d46ee",
                                      "line-height": "36px",
                                      "padding-left": "10px",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showDialog(
                                          _vm.viewIndex,
                                          0,
                                          _vm.viewData[_vm.viewIndex]
                                            .modelDetail.navModel.navType,
                                          _vm.viewData[_vm.viewIndex]
                                            .modelDetail.navModel
                                            .goodsSelectedId
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.viewData[_vm.viewIndex]
                                            .modelDetail.navModel.funcName
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.viewData[_vm.viewIndex].modelType == 6
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-table",
                          {
                            ref: "activeTable",
                            attrs: {
                              data: _vm.viewData[_vm.viewIndex].modelDetail
                                .activityNavList,
                              "row-key": "id",
                              "default-expand-all": "",
                              "tree-props": {
                                children: "children",
                                hasChildren: "hasChildren",
                              },
                              "header-cell-style": {
                                background: "#F5F6FA",
                                color: "#303033",
                                "font-weight": "bold",
                                "text-align": "left",
                              },
                            },
                            on: { "expand-change": _vm.getTypeChange },
                          },
                          [
                            _c("el-table-column", {
                              attrs: { label: "排序", width: "80px" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return scope.row.showType < 3
                                        ? [
                                            _c("p", [
                                              _vm._v(_vm._s(scope.row.id)),
                                            ]),
                                          ]
                                        : undefined
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { label: "排版类型", width: "150px" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.showType < 3
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      placeholder: "请选择",
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.getShowType(
                                                          $event,
                                                          _vm.viewIndex,
                                                          scope.row.id
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: scope.row.showType,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "showType",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.showType",
                                                    },
                                                  },
                                                  [
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "一栏",
                                                        value: 1,
                                                      },
                                                    }),
                                                    _c("el-option", {
                                                      attrs: {
                                                        label: "两栏",
                                                        value: 2,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        scope.row.showType == 3
                                          ? _c("p", [_vm._v("子类")])
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3214034043
                              ),
                            }),
                            _c(
                              "el-table-column",
                              {
                                attrs: {
                                  label: "图片",
                                  prop: "imgUrl",
                                  width: "150px",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("upload-picture", {
                                            attrs: {
                                              imageUrl: scope.row.imgUrl,
                                            },
                                            on: {
                                              getUrl: function ($event) {
                                                return _vm.getImage(
                                                  $event,
                                                  _vm.viewIndex,
                                                  scope.row
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3543876571
                                ),
                              },
                              [
                                _c(
                                  "template",
                                  { slot: "header" },
                                  [
                                    _c(
                                      "el-popover",
                                      {
                                        staticStyle: {
                                          overflow: "hidden",
                                          padding: "0",
                                        },
                                        attrs: {
                                          placement: "bottom-end",
                                          width: "250",
                                          trigger: "hover",
                                          "visible-arrow": "false",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "active-pic-tips" },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "active-pic-title",
                                              },
                                              [_vm._v("一栏（高度不限制）")]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "onegag" },
                                              [
                                                _c("p", [_vm._v("建议尺寸")]),
                                                _c("p", [_vm._v("686*168px")]),
                                              ]
                                            ),
                                            _c(
                                              "p",
                                              {
                                                staticClass: "active-pic-title",
                                              },
                                              [_vm._v("两栏")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "justify-content":
                                                    "space-between",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "onegag twogag",
                                                  },
                                                  [
                                                    _c("p", [
                                                      _vm._v("建议尺寸"),
                                                    ]),
                                                    _c("p", [
                                                      _vm._v("338*168px"),
                                                    ]),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "onegag twogag",
                                                  },
                                                  [
                                                    _c("p", [
                                                      _vm._v("建议尺寸"),
                                                    ]),
                                                    _c("p", [
                                                      _vm._v("338*168px"),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "center",
                                            },
                                            attrs: { slot: "reference" },
                                            slot: "reference",
                                          },
                                          [
                                            _c("p", [_vm._v("图片")]),
                                            _c("img", {
                                              staticStyle: {
                                                width: "18px",
                                                height: "18px",
                                              },
                                              attrs: {
                                                src: require("../../../assets/icon/icon_qipao.png"),
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              2
                            ),
                            _c("el-table-column", {
                              attrs: { label: "关联类型", width: "150px" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.navModel.navType == 0
                                          ? _c("p", [_vm._v("-")])
                                          : _vm._e(),
                                        scope.row.navModel.navType == 1
                                          ? _c("p", [_vm._v("功能跳转")])
                                          : _vm._e(),
                                        scope.row.navModel.navType == 2
                                          ? _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.navModel.navType ==
                                                    2 &&
                                                    _vm.classifyType == "2" &&
                                                    scope.row.navModel.labelId
                                                    ? "分类标签"
                                                    : "分类类目"
                                                )
                                              ),
                                            ])
                                          : _vm._e(),
                                        scope.row.navModel.navType == 3
                                          ? _c("p", [_vm._v("商品")])
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                694616236
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { label: "关联页面" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "toselect",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showDialog(
                                                  _vm.viewIndex,
                                                  scope.row,
                                                  scope.row.navModel.navType,
                                                  scope.row.navModel
                                                    .goodsSelectedId
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.navModel.funcName
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1649848387
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { label: "活动名称" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "请输入名称",
                                            maxlength: "8",
                                            "show-word-limit": "",
                                          },
                                          model: {
                                            value:
                                              scope.row.navModel.activeName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row.navModel,
                                                "activeName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.navModel.activeName",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                4137920199
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { label: "操作", align: "center" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.id - 1 <
                                          _vm.viewData[_vm.viewIndex]
                                            .modelDetail.activityNavList
                                            .length -
                                            1 && scope.row.showType != 3
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-right": "12px",
                                                  color: "#2d46ee",
                                                  cursor: "pointer",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toTableDown(
                                                      _vm.viewIndex,
                                                      scope.row.id
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("下移")]
                                            )
                                          : _vm._e(),
                                        scope.$index > 0 &&
                                        scope.row.showType != 3
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-right": "12px",
                                                  color: "#2d46ee",
                                                  cursor: "pointer",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toTabelUp(
                                                      _vm.viewIndex,
                                                      scope.row.id
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("上移")]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "red",
                                              cursor: "pointer",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.tableDel(
                                                  _vm.viewIndex,
                                                  scope.row.id,
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2847738634
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.viewData[_vm.viewIndex].modelType == 7
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "p",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                "margin-right": "8px",
                              },
                            },
                            [_vm._v("商品类型")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.showGoodsDialog(_vm.viewIndex)
                                },
                              },
                            },
                            [_vm._v("选择商品")]
                          ),
                        ],
                        1
                      ),
                      _vm.viewData[_vm.viewIndex].modelDetail.goodsList.length >
                      0
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-table",
                                {
                                  attrs: {
                                    data: _vm.viewData[_vm.viewIndex]
                                      .modelDetail.goodsList,
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      type: "index",
                                      label: "排序",
                                      width: "80px",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "商品图片",
                                      width: "100px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("img", {
                                                staticStyle: {
                                                  width: "64px",
                                                  height: "64px",
                                                },
                                                attrs: {
                                                  src: scope.row.imgUrl,
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2409208522
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "商品名称",
                                      prop: "goodsName",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "操作",
                                      align: "center",
                                      width: "150px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.$index <
                                              _vm.viewData[_vm.viewIndex]
                                                .modelDetail.goodsList.length -
                                                1
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-right": "12px",
                                                        color: "#2d46ee",
                                                        cursor: "pointer",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.toTableDown(
                                                            _vm.viewIndex,
                                                            scope.$index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("下移")]
                                                  )
                                                : _vm._e(),
                                              scope.$index > 0
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-right": "12px",
                                                        color: "#2d46ee",
                                                        cursor: "pointer",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.toTabelUp(
                                                            _vm.viewIndex,
                                                            scope.$index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("上移")]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "red",
                                                    cursor: "pointer",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.tableDel(
                                                        _vm.viewIndex,
                                                        scope.$index
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("删除")]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2559627834
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
        _c("div", { staticClass: "bottom-box" }, [
          _c(
            "div",
            { staticClass: "bottom-btn", on: { click: _vm.saveIndexTemplate } },
            [_vm._v("保存")]
          ),
        ]),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "功能选择",
            "append-to-body": true,
            visible: _vm.dialogVisible,
            width: "898",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "function-box" }, [
            _c(
              "div",
              { staticClass: "function-left" },
              _vm._l(_vm.functionLeft, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "function-item",
                    class: {
                      "function-item-active": _vm.functionIndex == index,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectFunction(index)
                      },
                    },
                  },
                  [
                    _c("span", [_vm._v(_vm._s(item))]),
                    _c("i", { staticClass: "el-icon-arrow-right" }),
                  ]
                )
              }),
              0
            ),
            _c("div", { staticClass: "function-right" }, [
              _vm.functionIndex == 0
                ? _c("div", { staticClass: "nopage" }, [
                    _c(
                      "div",
                      { staticClass: "select-box select-box-active" },
                      [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: "1" },
                            model: {
                              value: _vm.radio,
                              callback: function ($$v) {
                                _vm.radio = $$v
                              },
                              expression: "radio",
                            },
                          },
                          [_vm._v("不关联页面")]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.functionIndex == 1
                ? _c(
                    "div",
                    { staticClass: "nopage" },
                    _vm._l(_vm.functionInlet, function (item) {
                      return _c(
                        "div",
                        {
                          staticClass: "select-box",
                          class: {
                            "select-box-active":
                              item.label == _vm.functionInletRadio,
                          },
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: item.label },
                              model: {
                                value: _vm.functionInletRadio,
                                callback: function ($$v) {
                                  _vm.functionInletRadio = $$v
                                },
                                expression: "functionInletRadio",
                              },
                            },
                            [_vm._v(_vm._s(item.name))]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm.functionIndex == 2 && _vm.classifyType == "2"
                ? _c(
                    "div",
                    { staticClass: "nopage" },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "margin-bottom": "30px",
                          },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.tagName,
                                expression: "tagName",
                              },
                            ],
                            staticClass: "search-ipt",
                            attrs: {
                              type: "text",
                              placeholder: "请输入标签名称",
                            },
                            domProps: { value: _vm.tagName },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.tagName = $event.target.value
                              },
                            },
                          }),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                height: "36px",
                                "line-height": "normal",
                                "margin-left": "18px",
                              },
                              attrs: { type: "primary", size: "mini" },
                              on: { click: _vm.getLabelList },
                            },
                            [_vm._v("查询")]
                          ),
                        ],
                        1
                      ),
                      _vm._l(_vm.labelList, function (item) {
                        return _c(
                          "div",
                          {
                            staticClass: "select-box",
                            class: {
                              "select-box-active": item.id == _vm.labelId,
                            },
                          },
                          [
                            _c(
                              "el-radio",
                              {
                                attrs: { label: item.id },
                                model: {
                                  value: _vm.labelId,
                                  callback: function ($$v) {
                                    _vm.labelId = $$v
                                  },
                                  expression: "labelId",
                                },
                              },
                              [_vm._v(_vm._s(item.tagName))]
                            ),
                          ],
                          1
                        )
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "pagibox",
                          staticStyle: {
                            position: "static",
                            "justify-content": "center",
                            "margin-top": "20px",
                          },
                        },
                        [
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.labelPageNo,
                              "page-sizes": [5, 10, 20, 30],
                              "page-size": _vm.labelPageSize,
                              layout: "total, sizes, prev, pager, next, jumper",
                              total: _vm.labelTotalNum,
                            },
                            on: {
                              "size-change": _vm.handleSizeChangeLabel,
                              "current-change": _vm.handleCurrentChangeLabel,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.functionIndex == 2 && _vm.classifyType == "1"
                ? _c("div", { staticClass: "nopage" }, [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.categoryName,
                              expression: "categoryName",
                            },
                          ],
                          staticClass: "search-ipt",
                          attrs: {
                            type: "text",
                            placeholder: "请输入类目名称",
                          },
                          domProps: { value: _vm.categoryName },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.categoryName = $event.target.value
                            },
                          },
                        }),
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              height: "36px",
                              "line-height": "normal",
                              "margin-left": "18px",
                            },
                            attrs: { type: "primary", size: "mini" },
                            on: { click: _vm.searchCate },
                          },
                          [_vm._v("查询")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "categary-box" },
                      _vm._l(_vm.rootCategory, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "categary-item",
                            class: {
                              "categary-active": item.id == _vm.rootCategoryId,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.swicthRootCate(item.id, item.name)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(item.name) + " ")]
                        )
                      }),
                      0
                    ),
                    _c(
                      "div",
                      { staticStyle: { height: "72%", "overflow-y": "auto" } },
                      _vm._l(_vm.category, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: item.id,
                            staticClass: "select-box",
                            class: {
                              "select-box-active": item.id == _vm.categoryId,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.swicthCate(item.id, item.name)
                              },
                            },
                          },
                          [
                            _c(
                              "el-radio",
                              {
                                attrs: { label: item.id },
                                model: {
                                  value: _vm.categoryId,
                                  callback: function ($$v) {
                                    _vm.categoryId = $$v
                                  },
                                  expression: "categoryId",
                                },
                              },
                              [_vm._v(_vm._s(item.name))]
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "pagibox",
                        staticStyle: { position: "static" },
                      },
                      [
                        _c("el-pagination", {
                          attrs: {
                            "current-page": _vm.catePageNo,
                            "page-sizes": [5, 10, 20, 30],
                            "page-size": _vm.catePageSize,
                            layout: "total, sizes, prev, pager, next, jumper",
                            total: _vm.cateTotalNum,
                          },
                          on: {
                            "size-change": _vm.handleSizeChangecate,
                            "current-change": _vm.handleCurrentChangecate,
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.functionIndex == 3
                ? _c(
                    "div",
                    {
                      staticClass: "nopage",
                      staticStyle: {
                        position: "relative",
                        width: "100%",
                        height: "100%",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "margin-bottom": "18px",
                          },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.goodsInfo,
                                expression: "goodsInfo",
                              },
                            ],
                            staticClass: "search-ipt",
                            attrs: {
                              type: "text",
                              placeholder: "请输入商品名称/商品编号",
                            },
                            domProps: { value: _vm.goodsInfo },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.goodsInfo = $event.target.value
                              },
                            },
                          }),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                height: "36px",
                                "line-height": "normal",
                                "margin-left": "18px",
                              },
                              attrs: { type: "primary", size: "mini" },
                              on: { click: _vm.searchGoods },
                            },
                            [_vm._v("查询")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: { height: "83%", "overflow-y": "auto" },
                        },
                        _vm._l(_vm.goodsList, function (item) {
                          return _c(
                            "div",
                            {
                              staticClass: "select-box select-goods",
                              class: {
                                "select-box-active":
                                  item.goodsId == _vm.goodsSelectedId,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getGoodsName(item.goodsName)
                                },
                              },
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: item.goodsId },
                                  model: {
                                    value: _vm.goodsSelectedId,
                                    callback: function ($$v) {
                                      _vm.goodsSelectedId = $$v
                                    },
                                    expression: "goodsSelectedId",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "goods-box" }, [
                                    _c("img", {
                                      staticClass: "goods-img",
                                      attrs: { src: item.imgUrl, alt: "" },
                                    }),
                                    _c("div", [
                                      _c("p", [_vm._v(_vm._s(item.goodsName))]),
                                      _c("p", { staticClass: "goods-num" }, [
                                        _vm._v(
                                          "商品编号：" + _vm._s(item.goodsNo)
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "pagibox",
                          staticStyle: { position: "static" },
                        },
                        [
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.goodsPageNo,
                              "page-sizes": [5, 10, 20, 30],
                              "page-size": _vm.goodsPageSize,
                              layout: "total, sizes, prev, pager, next, jumper",
                              total: _vm.goodsTotalNum,
                            },
                            on: {
                              "size-change": _vm.handleSizeChange,
                              "current-change": _vm.handleCurrentChange,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirmFn } },
                [_vm._v("确 认")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": "",
            visible: _vm.goodsDialogVisible,
            width: "900px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.goodsDialogVisible = $event
            },
          },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v("选择商品"),
          ]),
          _c(
            "div",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "margin-bottom": "18px",
                    position: "absolute",
                    right: "24px",
                    top: "70px",
                    "z-index": "99",
                  },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.goodsInfo,
                        expression: "goodsInfo",
                      },
                    ],
                    staticClass: "search-ipt",
                    staticStyle: { width: "300px" },
                    attrs: {
                      type: "text",
                      placeholder: "请输入商品名称/商品编号",
                    },
                    domProps: { value: _vm.goodsInfo },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.goodsInfo = $event.target.value
                      },
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        height: "36px",
                        "line-height": "normal",
                        "margin-left": "18px",
                      },
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.searchGoods },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  ref: "goodsTable",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.goodsList },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", label: "全选", width: "55" },
                  }),
                  _c("el-table-column", {
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  height: "48px",
                                },
                              },
                              [
                                _c("img", {
                                  staticStyle: {
                                    width: "48px",
                                    height: "48px",
                                    "margin-right": "8px",
                                  },
                                  attrs: { src: scope.row.imgUrl, alt: "" },
                                }),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "flex-direction": "column",
                                      "justify-content": "space-between",
                                    },
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(_vm._s(scope.row.goodsName)),
                                    ]),
                                    _c("p", { staticClass: "goods-num" }, [
                                      _vm._v(
                                        "商品编号：" + _vm._s(scope.row.goodsNo)
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagibox", staticStyle: { position: "static" } },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.goodsPageNo,
                  "page-sizes": [5, 10, 20, 30],
                  "page-size": _vm.goodsPageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.goodsTotalNum,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.goodsDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.goodsConfirmFn },
                },
                [_vm._v("确 认")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": "",
            visible: _vm.delDialogVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.delDialogVisible = $event
            },
          },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _c("i", {
              staticClass: "el-icon-warning",
              staticStyle: { color: "red" },
            }),
            _vm._v(" 提示信息 "),
          ]),
          _c("div", [_vm._v("删除后不可恢复数据，是否继续？")]),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.delDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.deleteViewFn()
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "bread-small" }, [
      _c(
        "span",
        {
          staticStyle: {
            "font-size": "18px",
            "font-weight": "bold",
            "margin-right": "7px",
          },
        },
        [_vm._v("新增页面")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "search-left" }, [
      _c("img", {
        staticClass: "search-icon",
        attrs: {
          src: require("../../../assets/icon_search_36red@2x.png"),
          alt: "",
        },
      }),
      _c("p", [_vm._v("请输入搜索内容")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }